Base = App.loadClass 'grower::Angular/Operation/Machinery/BaseMachineryController'

class exports.ModalMachineryController extends Base
    constructor: (@scope, @transitions, @modal, @modalInstance, @machineryService, @q, @viewing, @editing, id, typeId, autoSelect) ->
        super @scope, @transitions, @modal, @machineryService, @q, @viewing, @editing, id, typeId

        # Don't want to deal with dynamicness so I hardcode
        if autoSelect.type
            @machineryService.getType(autoSelect.type)
            .then (type) =>
                @machinery.type = type
                @loadFormData()
                .then () =>
                    if autoSelect.crop
                        cropCategory = switch autoSelect.crop.name
                            when 'Corn', 'Corn Silage', 'Popcorn' then 'Corn'
                            when 'Alfalfa', 'Millet', 'Sorghum', 'Wheat' then 'Small Grains'
                            else autoSelect.crop.name
                        @machinery.crop = @formData.crops.find (crop) -> crop.name is cropCategory

    # Save Machinery
    save: () ->
        @setAlert
            msg: 'Saving machinery...'
            type: 'info'

        @machineryService.save @machinery
        .then (machine) =>
            @setAlert
                msg: "#{@machinery.type.name} saved!"
                type: 'success'
            @modalInstance.close machine
        .catch (error) =>
            @setAlert
                msg: error
                type: 'error'

    cancel: () ->
        @modalInstance.dismiss 'cancel machinery'
